import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Button, Stack, Typography } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

import { EvotruxDivider } from "components/EvotruxDivider";
import { useDisclosure } from "hooks";
import { formatQuotingUnitOfMeasure } from "utils/quotes";

import { BookNowProjectModal } from "../BookNowProjectModal";

interface CarrierProjectBookNowProps {
  shipment: CarrierCondensedShipment | undefined;
  sectionHeaderType: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  sectionSpace: string;
}

export function CarrierProjectBookNow(props: CarrierProjectBookNowProps) {
  const { shipment, sectionHeaderType, sectionSpace } = props;
  const {
    isOpen: bookNowOpen,
    onClose: onCloseBookNow,
    onOpen: onOpenBookNow,
  } = useDisclosure(false);

  if (
    !shipment?.book_now_info?.is_book_now ||
    shipment.shipment_status !== "ACTIVE" ||
    !shipment.is_partner_shipment ||
    shipment.info.type !== "MULTI_SHIPMENT_PROJECT"
  ) {
    return null;
  }

  return (
    <>
      <Stack
        id="book-now-section"
        direction="row"
        mt={sectionSpace}
        alignItems="center"
        spacing={1}
      >
        <Typography variant={sectionHeaderType}>Book Now</Typography>
        <Tooltip
          title={
            <Typography variant="h5">
              You can instantly book loads from this project for the price
              listed below, skipping the quoting process. Specify how many loads
              you want to book. If the price/equipment doesn&apos;t work for
              you, please submit a quote.
            </Typography>
          }
        >
          <InfoOutlinedIcon color="primary" fontSize="large" />
        </Tooltip>
      </Stack>
      <EvotruxDivider />
      <BookNowProjectModal
        shipment={shipment}
        visible={bookNowOpen}
        onClose={onCloseBookNow}
      />
      <Stack direction="row" spacing="1" sx={{ mt: "1rem" }}>
        <Button onClick={onOpenBookNow} variant="contained" color="success">
          {`BOOK NOW $${shipment.book_now_info.book_now_price} ${shipment.book_now_info.book_now_currency} per load`}{" "}
          {shipment.info.quoting_unit_of_measure !== "ALL_IN"
            ? formatQuotingUnitOfMeasure(
                shipment.info.quoting_unit_of_measure,
                false,
              )
            : ""}
        </Button>
      </Stack>
    </>
  );
}
